import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { IconModule } from 'app/icon/icon.module';
import { CoreModule } from 'app/core/core.module';
import { CounterModule } from 'app/core/modules/counter/counter.module';

import { SilentAuctionSlideShowComponent } from './components/silent-auction-slide-show/silent-auction-slide-show.component';
import { SlideShowSwiperComponent } from './components/slide-show-swiper/slide-show-swiper.component'
import { ActivityTimerPipe } from './pipes/activity-timer.pipe';

const routes:Routes = [{
  path: 'handle/:handle/ppid/:ppid',
  component: SilentAuctionSlideShowComponent,
}]

// silent-auction/6349443caad7ba14fec46ee5/auction-item/650325252c49ffabc0fe22b4
@NgModule({
  declarations: [
    SilentAuctionSlideShowComponent,
    SlideShowSwiperComponent,
    ActivityTimerPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { bindToComponentInputs: true, useHash: false, onSameUrlNavigation: "ignore" }),
    IconModule,
    CoreModule,
    CounterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SilentAuctionSlideShowModule { }
